import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

/**
 * Container styles for the entire feed item
 */
export const feedItemContainerStyles = css`
  background-color: ${colors.SECONDARY_300};
  border: 1px solid ${colors.SECONDARY_200};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`

/**
 * Header section styles
 */
export const headerStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

/**
 * Profile link styles
 */
export const profileLinkStyles = css`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
`

/**
 * Avatar container styles for positioning
 */
export const avatarContainerStyles = css`
  position: relative;
  width: 40px;
  height: 40px;
`

/**
 * Profile info section styles
 */
export const profileInfoStyles = css`
  display: flex;
  align-items: center;
  gap: 4px;
`

/**
 * More icon dropdown trigger styles
 */
export const moreIconStyles = css`
  cursor: pointer;
`

/**
 * Content section styles
 */
export const contentStyles = css`
  margin-bottom: 8px;
`

/**
 * Image container styles
 */
export const imageContainerStyles = css`
  margin-bottom: 16px;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  margin-top: 16px;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: ${colors.SECONDARY_400};
  overflow: hidden;
  .ant-image {
    width: 100% !important;
    height: 100% !important;
    border-radius: 8px !important;
  }
  .ant-image .ant-image-img {
    height: 100% !important;
    object-fit: contain !important;
  }
`

/**
 * Actions section styles
 */
export const actionsStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin-bottom: 16px;
  margin-top: 16px;
`

/**
 * Actions group container styles
 */
export const actionsGroupStyles = css`
  display: flex;
  gap: 8px;
`

/**
 * Action button base styles
 */
export const actionButtonStyles = css`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-radius: 8px;
  background: ${colors.SECONDARY_200};
  padding: 8px;
`

/**
 * External link button styles
 */
export const linkButtonStyles = css`
  text-decoration: none;
  display: flex;
  padding: 8px 8px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid ${colors.PRIMARY};
`

/**
 * Link text styles
 */
export const linkTextStyles = `
  display: flex;
  align-items: center;
  gap: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

/**
 * Returns avatar styles
 */
export const getAvatarStyles = () => css`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: contain;
`

/**
 * User profile picture overlay styles
 */
export const getUserProfileStyles = css`
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: contain;
  background-color: ${colors.WHITE};
  border: 1px solid ${colors.NEUTRAL_100};
`

/**
 * Separator line styles
 */
export const separatorStyles = css`
  width: 100%;
  height: 1px;
  background-color: ${colors.SECONDARY_200};
  margin-top: 8px;
  margin-bottom: 16px;
`

/**
 * Insights button styles
 */
export const insightsButtonStyles = css`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${colors.SECONDARY_200};
  }
  /* Hide for now */
  display: none;
`

/**
 * Header actions container styles
 */
export const headerActionsStyles = css`
  display: flex;
  align-items: center;
  gap: 8px;
`

/**
 * Delete comment button styles
 */
export const deleteCommentButtonStyles = css`
  display: flex;
  padding: 8px 16px 8px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid ${colors.ERROR_200};
  background: transparent;
  cursor: pointer;
  display: none;
`
